/* ============================================================
   GRENADINE — Sudoku (page Jeux, vue #sudoku-grenadine)
   Monte le jeu dans <div id="sd-app"></div>.
   Grilles générées à la volée : solution complète aléatoire
   (backtracking), puis retrait de cases en gardant une solution
   UNIQUE (compteur de solutions arrêté à 2).
   Sauvegarde (records + partie en cours) : localStorage 'gj-sudoku-v1'.
   ============================================================ */
(function(){
  'use strict';

  /* ---------- Moteur (sans DOM) ---------- */
  var PC=[0]; for(var p=1;p<512;p++) PC[p]=PC[p>>1]+(p&1);
  var RW=[],CL=[],BX=[];
  for(var q=0;q<81;q++){ RW[q]=q/9|0; CL[q]=q%9; BX[q]=((RW[q]/3|0)*3)+(CL[q]/3|0); }
  var PEERS=[];
  for(q=0;q<81;q++){ PEERS[q]=[]; for(var j=0;j<81;j++) if(j!==q && (RW[j]===RW[q]||CL[j]===CL[q]||BX[j]===BX[q])) PEERS[q].push(j); }

  function shuffle(a){ for(var i=a.length-1;i>0;i--){ var k=Math.random()*(i+1)|0, t=a[i]; a[i]=a[k]; a[k]=t; } return a; }

  /* Compte les solutions (jusqu'à `limit`). rand=true : ordre des chiffres aléatoire.
     Renvoie {n: nombre trouvé (≤ limit), sol: première solution trouvée ou null}. */
  function solve(grid, limit, rand){
    var g=grid.slice(), rm=[0,0,0,0,0,0,0,0,0], cm=rm.slice(), bm=rm.slice(), em=[], n=0, out=null, i, v, b;
    for(i=0;i<81;i++){
      v=g[i];
      if(v){ b=1<<(v-1); if((rm[RW[i]]|cm[CL[i]]|bm[BX[i]])&b) return {n:0,sol:null}; rm[RW[i]]|=b; cm[CL[i]]|=b; bm[BX[i]]|=b; }
      else em.push(i);
    }
    function rec(left){
      if(!left){ n++; if(!out) out=g.slice(); return; }
      var best=-1, mask=0, bc=10, k, x, m, c;
      for(k=0;k<em.length;k++){
        x=em[k]; if(g[x]) continue;
        m=~(rm[RW[x]]|cm[CL[x]]|bm[BX[x]])&511; c=PC[m];
        if(c<bc){ bc=c; best=x; mask=m; if(c<2) break; }
      }
      if(!bc) return;
      var ds=[]; for(k=0;k<9;k++) if(mask&(1<<k)) ds.push(k);
      if(rand) shuffle(ds);
      for(k=0;k<ds.length;k++){
        var bit=1<<ds[k];
        g[best]=ds[k]+1; rm[RW[best]]|=bit; cm[CL[best]]|=bit; bm[BX[best]]|=bit;
        rec(left-1);
        rm[RW[best]]&=~bit; cm[CL[best]]&=~bit; bm[BX[best]]&=~bit; g[best]=0;
        if(n>=limit) return;
      }
    }
    rec(em.length);
    return {n:n, sol:out};
  }

  var LEVELS={
    facile:   {label:'Facile',    min:40, max:45},
    moyen:    {label:'Moyen',     min:32, max:36},
    difficile:{label:'Difficile', min:27, max:30},
    expert:   {label:'Expert',    min:23, max:25}
  };
  var ORDER=['facile','moyen','difficile','expert'];

  /* Génère une grille : {puzzle:[81] (0 = vide), solution:[81], givens:n} */
  function generate(level, budgetMs){
    var L=LEVELS[level]||LEVELS.facile, t0=Date.now(), budget=budgetMs||1200, best=null;
    var target=L.min+(Math.random()*(L.max-L.min+1)|0);
    var empty=[]; for(var i=0;i<81;i++) empty.push(0);
    do{
      var sol=solve(empty,1,true).sol, g=sol.slice(), giv=81, ord=[];
      for(i=0;i<81;i++) ord.push(i);
      shuffle(ord);
      for(var k=0;k<81 && giv>target;k++){
        var x=ord[k], t=g[x]; g[x]=0;
        if(solve(g,2).n!==1) g[x]=t; else giv--;
      }
      if(!best || giv<best.givens) best={puzzle:g, solution:sol, givens:giv};
      if(giv<=L.max) break;
    }while(Date.now()-t0<budget);
    return best;
  }

  var api={generate:generate, solve:solve, LEVELS:LEVELS, ORDER:ORDER, PEERS:PEERS};
  if(typeof window!=='undefined') window.GJSudoku=api;
  if(typeof module!=='undefined' && module.exports) module.exports=api;
  if(typeof document==='undefined') return;

  /* ---------- Interface ---------- */
  var app=document.getElementById('sd-app'); if(!app) return;

  var KEY='gj-sudoku-v1', MAX_ERR=3, MAX_HINT=3;
  var data=load();
  var S=null, sel=-1, notesMode=false, hist=[], lastTick=0, sinceSave=0;

  function load(){
    var d=null;
    try{ d=JSON.parse(localStorage.getItem(KEY)||'null'); }catch(e){}
    if(!d || typeof d!=='object') d={};
    if(!d.best || typeof d.best!=='object') d.best={};
    if(d.cur && !(d.cur.puz && d.cur.puz.length===81 && d.cur.sol && d.cur.sol.length===81 && LEVELS[d.cur.lv])) d.cur=null;
    return d;
  }
  function save(){
    data.cur = (S && !S.done && !S.over) ? {lv:S.lv,puz:S.puz,sol:S.sol,val:S.val,notes:S.notes,hint:S.hint,mist:S.mist,hints:S.hints,t:Math.round(S.t),sel:sel} : null;
    try{ localStorage.setItem(KEY, JSON.stringify(data)); }catch(e){}
  }
  function fmt(ms){
    var s=Math.floor(ms/1000), h=Math.floor(s/3600), m=Math.floor(s%3600/60), x=s%60;
    return (h? h+':'+(m<10?'0':'')+m : m)+':'+(x<10?'0':'')+x;
  }

  var I={
    undo:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',
    erase:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 21-4.3-4.3a1 1 0 0 1 0-1.4l9.6-9.6a1 1 0 0 1 1.4 0l5.6 5.6a1 1 0 0 1 0 1.4L13 21"/><path d="M22 21H7"/><path d="m5 11 9 9"/></svg>',
    notes:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>',
    hint:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.1 14c.2-1 .7-1.7 1.4-2.5A4.6 4.6 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.4 2.5"/></svg>'
  };

  var boxes='';
  for(var b=0;b<9;b++){
    boxes+='<div class="sd-box">';
    for(var k=0;k<9;k++){
      var idx=((b/3|0)*3+(k/3|0))*9+(b%3)*3+k%3;
      boxes+='<div class="sd-c" data-i="'+idx+'" role="gridcell"></div>';
    }
    boxes+='</div>';
  }
  var pad=''; for(var d=1;d<=9;d++) pad+='<button type="button" class="sd-key" data-d="'+d+'" aria-label="Chiffre '+d+'">'+d+'</button>';

  app.innerHTML=
    '<div class="sd-pick" hidden>'+
      '<p class="sd-label">Choisissez votre niveau</p>'+
      '<button type="button" class="sd-resume" data-act="resume" hidden></button>'+
      '<div class="sd-levels">'+ORDER.map(function(l){
        return '<button type="button" class="sd-lvl" data-lv="'+l+'"><span class="sd-lvl-n">'+LEVELS[l].label+'</span>'+
          '<span class="sd-lvl-s">'+LEVELS[l].min+' à '+LEVELS[l].max+' chiffres donnés</span><span class="sd-lvl-b" data-best="'+l+'"></span></button>';
      }).join('')+'</div>'+
      '<p class="sd-rules">Chaque ligne, chaque colonne et chaque carré de 3×3 doit contenir les chiffres de 1 à 9, une seule fois. Trois erreurs et la partie s’arrête.</p>'+
    '</div>'+
    '<div class="sd-game" hidden>'+
      '<div class="sd-bar"><p class="sd-label sd-cur"></p><p class="sd-stats"><span class="sd-err"></span><span class="sd-time">0:00</span></p></div>'+
      '<div class="sd-board"><div class="sd-grid" role="grid" aria-label="Grille de sudoku">'+boxes+'</div>'+
        '<div class="sd-over" hidden><div class="sd-over-in"><p class="sd-over-t"></p><p class="sd-over-s"></p><p class="sd-over-r"></p>'+
        '<div class="sd-over-a"><button type="button" class="sd-btn sd-btn--dark" data-act="again">Rejouer</button><button type="button" class="sd-btn sd-btn--soft" data-act="levels">Changer de niveau</button></div></div></div>'+
      '</div>'+
      '<div class="sd-tools">'+
        '<button type="button" class="sd-tool" data-act="undo"><span class="sd-ic">'+I.undo+'</span><span class="sd-tl">Annuler</span></button>'+
        '<button type="button" class="sd-tool" data-act="erase"><span class="sd-ic">'+I.erase+'</span><span class="sd-tl">Effacer</span></button>'+
        '<button type="button" class="sd-tool sd-tool--notes" data-act="notes" aria-pressed="false"><span class="sd-ic">'+I.notes+'</span><span class="sd-tl">Notes</span></button>'+
        '<button type="button" class="sd-tool" data-act="hint"><span class="sd-ic">'+I.hint+'<span class="sd-badge"></span></span><span class="sd-tl">Indice</span></button>'+
      '</div>'+
      '<div class="sd-pad">'+pad+'</div>'+
      '<div class="sd-foot"><button type="button" class="sd-btn sd-btn--soft" data-act="levels">Changer de niveau</button><button type="button" class="sd-btn sd-btn--soft" data-act="new">Nouvelle grille</button></div>'+
    '</div>';

  function $(s){ return app.querySelector(s); }
  var pickEl=$('.sd-pick'), gameEl=$('.sd-game'), gridEl=$('.sd-grid'), overEl=$('.sd-over'), timeEl=$('.sd-time'), errEl=$('.sd-err'), curEl=$('.sd-cur');
  var cellEls=[], keyEls=app.querySelectorAll('.sd-key'), resumeEl=$('.sd-resume');
  var all=app.querySelectorAll('.sd-c');
  for(var z=0;z<all.length;z++) cellEls[+all[z].getAttribute('data-i')]=all[z];

  /* ---------- Écrans ---------- */
  function showPick(){
    pickEl.hidden=false; gameEl.hidden=true;
    ORDER.forEach(function(l){
      var t=data.best[l], el=app.querySelector('[data-best="'+l+'"]');
      el.textContent = t ? 'Record : '+fmt(t) : 'Aucun record';
      el.classList.toggle('is-rec', !!t);
    });
    var c=data.cur;
    resumeEl.hidden=!c;
    if(c) resumeEl.innerHTML='Reprendre la partie <span>'+LEVELS[c.lv].label+' · '+fmt(c.t||0)+'</span>';
  }
  function startNew(lv){
    var g=generate(lv), z81=[];
    for(var i=0;i<81;i++) z81.push(0);
    S={lv:lv, puz:g.puzzle, sol:g.solution, val:z81.slice(), notes:z81.slice(), hint:z81.slice(), mist:0, hints:0, t:0, done:false, over:false};
    sel=-1; for(i=0;i<81;i++) if(!S.puz[i]){ sel=i; break; }
    enterGame();
  }
  function resume(){
    var c=data.cur; if(!c) return;
    S={lv:c.lv, puz:c.puz, sol:c.sol, val:c.val, notes:c.notes, hint:c.hint, mist:c.mist|0, hints:c.hints|0, t:+c.t||0, done:false, over:false};
    sel=typeof c.sel==='number'?c.sel:-1;
    enterGame();
  }
  function enterGame(){
    hist=[]; notesMode=false; lastTick=0;
    pickEl.hidden=true; gameEl.hidden=false; overEl.hidden=true;
    curEl.textContent='Niveau '+LEVELS[S.lv].label;
    save(); paint();
  }

  /* ---------- Jeu ---------- */
  function editable(i){ return i>=0 && !S.puz[i] && !S.hint[i]; }
  function value(i){ return S.puz[i]||S.val[i]; }
  function snap(list){ return list.map(function(i){ return {i:i, v:S.val[i], n:S.notes[i]}; }); }
  function clearPeerNotes(i,d){
    var bit=1<<(d-1), ch=[];
    PEERS[i].forEach(function(j){ if(S.notes[j]&bit){ ch.push(j); } });
    return ch;
  }
  function active(){ return S && !S.done && !S.over; }

  function place(d){
    if(!active() || !editable(sel)) return;
    var i=sel, bit=1<<(d-1);
    if(notesMode){
      if(S.val[i]) return;
      hist.push(snap([i])); S.notes[i]^=bit;
    }else{
      if(S.val[i]===d) return;
      var peers = d===S.sol[i] ? clearPeerNotes(i,d) : [];
      hist.push(snap([i].concat(peers)));
      S.val[i]=d; S.notes[i]=0;
      peers.forEach(function(j){ S.notes[j]&=~bit; });
      if(d!==S.sol[i]){
        S.mist++;
        var el=cellEls[i]; el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake');
        if(S.mist>=MAX_ERR){ S.over=true; finish(false); }
      }else checkDone();
    }
    save(); paint();
  }
  function erase(){
    if(!active() || !editable(sel)) return;
    if(!S.val[sel] && !S.notes[sel]) return;
    hist.push(snap([sel])); S.val[sel]=0; S.notes[sel]=0;
    save(); paint();
  }
  function undo(){
    if(!active()) return;
    var h=hist.pop(); if(!h) return;
    h.forEach(function(c){ if(!S.hint[c.i]){ S.val[c.i]=c.v; S.notes[c.i]=c.n; } });
    if(h[0]) sel=h[0].i;
    save(); paint();
  }
  function hint(){
    if(!active() || S.hints>=MAX_HINT) return;
    var i=-1;
    if(editable(sel) && S.val[sel]!==S.sol[sel]) i=sel;
    else{
      var c=[]; for(var k=0;k<81;k++) if(editable(k) && S.val[k]!==S.sol[k]) c.push(k);
      if(!c.length) return;
      i=c[Math.random()*c.length|0];
    }
    var d=S.sol[i], bit=1<<(d-1);
    S.val[i]=d; S.notes[i]=0; S.hint[i]=1; S.hints++;
    clearPeerNotes(i,d).forEach(function(j){ S.notes[j]&=~bit; });
    sel=i; checkDone(); save(); paint();
  }
  function checkDone(){
    for(var i=0;i<81;i++) if(value(i)!==S.sol[i]) return;
    S.done=true; finish(true);
  }
  function finish(won){
    var tEl=overEl.querySelector('.sd-over-t'), sEl=overEl.querySelector('.sd-over-s'), rEl=overEl.querySelector('.sd-over-r');
    overEl.classList.toggle('is-win', won);
    if(won){
      var prev=data.best[S.lv], rec=!prev || S.t<prev;
      if(rec) data.best[S.lv]=Math.round(S.t);
      tEl.textContent='Bravo !';
      sEl.textContent='Grille '+LEVELS[S.lv].label.toLowerCase()+' terminée en '+fmt(S.t);
      rEl.textContent= rec ? (prev?'Nouveau record ! 🩷':'Premier record enregistré 🩷') : 'Votre record : '+fmt(prev);
    }else{
      tEl.innerHTML='Partie<br>terminée';
      sEl.textContent='3 erreurs : cette grille a eu le dernier mot.';
      rEl.textContent='On retente ?';
    }
    sel=-1; overEl.hidden=false;
  }

  function paint(){
    if(!S) return;
    var sv = sel>=0 ? value(sel) : 0, count=[0,0,0,0,0,0,0,0,0,0];
    for(var i=0;i<81;i++){
      var el=cellEls[i], v=value(i), given=!!S.puz[i], bad=!given && v && v!==S.sol[i];
      if(v && !bad) count[v]++;
      var cls='sd-c';
      if(given) cls+=' is-given'; else if(S.hint[i]) cls+=' is-hint'; else if(v) cls+=' is-user';
      if(bad) cls+=' is-bad';
      if(i===sel) cls+=' is-sel';
      else if(sv && v===sv) cls+=' is-same';
      else if(sel>=0 && (RW[i]===RW[sel]||CL[i]===CL[sel]||BX[i]===BX[sel])) cls+=' is-peer';
      if(el.classList.contains('is-shake') && bad) cls+=' is-shake';
      el.className=cls;
      var html;
      if(v) html='<span class="sd-v">'+v+'</span>';
      else if(S.notes[i]){
        html='<span class="sd-n">';
        for(var d=1;d<=9;d++) html+='<span>'+(S.notes[i]&(1<<(d-1))?d:'')+'</span>';
        html+='</span>';
      }else html='';
      if(el._h!==html){ el.innerHTML=html; el._h=html; }
      el.setAttribute('aria-label','Ligne '+(RW[i]+1)+', colonne '+(CL[i]+1)+(v?', '+v:', vide'));
    }
    for(i=0;i<keyEls.length;i++){
      var dk=i+1, full=count[dk]>=9;
      keyEls[i].disabled=full || !active();
      keyEls[i].classList.toggle('is-full', full);
    }
    errEl.textContent='Erreurs : '+S.mist+'/'+MAX_ERR;
    errEl.classList.toggle('is-on', S.mist>0);
    var nb=app.querySelector('.sd-tool--notes'); nb.classList.toggle('is-on', notesMode); nb.setAttribute('aria-pressed', notesMode?'true':'false');
    gameEl.classList.toggle('is-notes', notesMode);
    var left=MAX_HINT-S.hints, hb=app.querySelector('[data-act="hint"]');
    hb.querySelector('.sd-badge').textContent=left;
    hb.disabled=!left || !active();
    app.querySelector('[data-act="undo"]').disabled=!hist.length || !active();
    app.querySelector('[data-act="erase"]').disabled=!active();
    nb.disabled=!active();
    timeEl.textContent=fmt(S.t);
  }

  /* ---------- Chrono (pause si la vue est cachée ou l'onglet inactif) ---------- */
  function visible(){ return !document.hidden && app.offsetParent!==null && !gameEl.hidden; }
  setInterval(function(){
    var now=Date.now();
    if(!S || !active() || !visible()){ lastTick=0; return; }
    if(lastTick){ var dt=Math.min(now-lastTick, 2000); S.t+=dt; sinceSave+=dt; }
    lastTick=now;
    timeEl.textContent=fmt(S.t);
    if(sinceSave>=5000){ sinceSave=0; save(); }
  }, 250);
  document.addEventListener('visibilitychange', function(){ if(document.hidden && S && active()) save(); });

  /* ---------- Événements ---------- */
  app.addEventListener('click', function(e){
    var c=e.target.closest('.sd-c');
    if(c){ if(active()){ sel=+c.getAttribute('data-i'); paint(); } return; }
    var k=e.target.closest('.sd-key'); if(k){ place(+k.getAttribute('data-d')); return; }
    var lv=e.target.closest('[data-lv]'); if(lv){ startNew(lv.getAttribute('data-lv')); return; }
    var a=e.target.closest('[data-act]'); if(!a || a.disabled) return;
    switch(a.getAttribute('data-act')){
      case 'undo': undo(); break;
      case 'erase': erase(); break;
      case 'notes': notesMode=!notesMode; paint(); break;
      case 'hint': hint(); break;
      case 'again': case 'new': startNew(S?S.lv:'facile'); break;
      case 'levels': save(); showPick(); break;
      case 'resume': resume(); break;
    }
  });
  document.addEventListener('keydown', function(e){
    if(!S || gameEl.hidden || app.offsetParent===null || e.ctrlKey || e.metaKey || e.altKey) return;
    var t=e.target, tag=t && t.tagName;
    if(tag==='INPUT' || tag==='TEXTAREA' || tag==='SELECT' || (t && t.isContentEditable)) return;
    var key=e.key;
    if(/^[1-9]$/.test(key)){ e.preventDefault(); place(+key); return; }
    if(key==='Backspace' || key==='Delete' || key==='0'){ e.preventDefault(); erase(); return; }
    if(key==='n' || key==='N'){ notesMode=!notesMode; paint(); return; }
    var mv={ArrowUp:-9, ArrowDown:9, ArrowLeft:-1, ArrowRight:1}[key];
    if(mv && active()){
      e.preventDefault();
      if(sel<0){ sel=40; }
      else{
        var r=RW[sel], c=CL[sel];
        if(mv===-9) r=(r+8)%9; else if(mv===9) r=(r+1)%9; else if(mv===-1) c=(c+8)%9; else c=(c+1)%9;
        sel=r*9+c;
      }
      paint();
    }
  });

  showPick();

  /* toujours revenir au choix du niveau quand on rouvre le jeu */
  document.addEventListener('gj:open',function(e){ if(e.detail==='sudoku-grenadine'){ try{ showPick(); }catch(err){} } });
})();
